<!--动态图对象 右键属性-->
<template>
  <div>
    <gs-modal
      v-loading="loading"
      v-model="visible"
      :before-close="beforeClose"
      :before-confirm="beforeConfirm"
      :title="isEdit?name+'-记事本':''+'记事本'"
      :has-form="true"
      class="my-test-class"
      @close="close"
      @confirm="handleConfirm"
    >
      <gs-form
        :model="form"
        label-width="95px"
        label-position="left"
        gap="small"
      >
        <gs-form-item
          label="名称"
          prop="target"
          class="form-item-radio"
        >
          <gs-input
            ref="nameInput"
            v-model="name"
          />
        </gs-form-item>
        <gs-form-item
          label="内容"
          prop="target"
          class="form-item-radio"
        >
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4}"
            placeholder="请输入内容"
            v-model="description">
          </el-input>
        </gs-form-item>
      </gs-form>
    </gs-modal>
  </div>
</template>

<script type="text/ecmascript-6">
  import { mapState, mapMutations } from 'vuex'
  import service from '../../service/leftService.js'
  import eventBus from '../timeChart/vue.js'
  export default {
    components: {

    },
    data () {
      return {
        textarea:'',
        radio: 1,
        objectInfo: {},
        loading: false,
        activeName: 'first',
        form: {
          
        },
        description: '',
        checked: '',
        options: [
          {
            label: '秒(s)',
            value: 's'
          }, {
            label: '分(m)',
            value: 'm'
          }, {
            label: '时(h)',
            value: 'h'
          }, {
            label: '天(d)',
            value: 'd'
          }
        ],
        visibleAdd: false,
        visibleProperties: false,
        addList: [],
        props: {
          label: 'name',
          disabled: 'type:folder'
        },
        selectList: [],
        name: '',
        showList: [],
        row: '',
        isEdit: false,
        oldData: {}
      }
    },
    computed: {
      ...mapState({
        visible: 'noteBookShow',
        nodeData: 'objectInfo'
      })
    },
    watch: {
      tableData () {
        this.form.objList = this.tableData
      },
      nodeData () {

      },
      visible () {
        if (this.visible) {
          this.objectInfo = JSON.parse(JSON.stringify(this.nodeData))
          setTimeout(() => {
            this.$refs.nameInput.focus()
          }, 100)
          if (JSON.stringify(this.objectInfo) !== '{}' && this.objectInfo.type === 'notebook') {
            this.isEdit = true
            this.activeName = 'first'
            this.form = this.objectInfo.attribute ? this.objectInfo.attribute : {}
            this.description = this.objectInfo.description ? this.objectInfo.description : ''
            this.name = this.objectInfo.name ? this.objectInfo.name : ''
            this.form.objectSeries = this.objectInfo.attribute.objectSeries ? JSON.parse(JSON.stringify(this.objectInfo.attribute.objectSeries)) : []
          } else {
            this.isEdit = false
            this.activeName = 'first'
            this.form = {
              objectSeries: [],
              primaryY_autoScale: true,
              primaryY_Mininum: 0,
              primaryY_maximum: 100,
              secondaryY_autoScale: true,
              secondaryY_Mininum: 0,
              secondaryY_maximum: 100,
              logInterval_value: 1,
              logInterval_unit: 's',
              maxLogNum: ''
            }
            this.description = ''
            this.name = ''
          }
        }
      }
    },
    created () {

    },
    mounted () {

    },
    methods: {
      ...mapMutations({
        close: 'NOTE_BOOK_HIDE',
        needReload: 'NOTE_BOOK_TREE'
      }),
      beforeClose () {
        this.close()
      },
      // cancel () {
      //   this.nodeData = this.oldData
      //   this.close()
      // },
      beforeConfirm (e, done) {
        if (this.name === null || this.name === '') {
          this.$Message.warning('名称不能为空!')
          return
        }
        if (!this.form.primaryY_autoScale) {
          if (this.form.primaryY_Mininum >= this.form.primaryY_maximum) {
            this.$Message.warning('Y轴最小值必须小于最大值')
            return
          }
        }
        if (!this.form.secondaryY_autoScale) {
          if (this.form.secondaryY_Mininum >= this.form.secondaryY_maximum) {
            this.$Message.warning('Y轴最小值必须小于最大值')
            return
          }
        }
        // done(false)可以阻止modal关闭
        done()
      },
      handleConfirm () {
        let _this = this
        this.loading = true
        let arr = []
        let backArr = JSON.parse(JSON.stringify(this.form.objectSeries))
        this.form.objectSeries.forEach(e => {
          arr.push(e.id)
        })
        this.form.objectSeries = arr
        if (this.objectInfo.id && this.objectInfo.type === 'notebook') {
          let param = {
            id: this.objectInfo.id,
            'name': this.name,
            'type': this.objectInfo.type,
            value: this.objectInfo.value,
            'parentId': this.objectInfo.parentId,
            'description': this.description,
            'attribute': this.form // 其他信息这里，键值对形式
          }
          service.renamePoint(param).then(res => {
            this.loading = false
            this.$Message.success('修改成功')
            _this.objectInfo.attribute.objectSeries = backArr
            this.close()
            this.objectInfo.name = this.name
            res.attribute.objectSeries = backArr
            this.$store.state.tabPanel = res
            this.$store.state.updateTreeNode = res
            this.description = ''
            this.name = ''
            // this.form = {
            //   objectSeries: []
            // }
            this.showList = []
            // eventBus.$emit('changeInterval', res)
          }).catch(err => {
            this.loading = false
            this.form.objectSeries = backArr
            this.$Message.error(err.message)
          })
        } else {
          let param = {
            'name': this.name,
            'type': 'notebook',
            'parentId': this.objectInfo.id,
            'description': this.description,
            'attribute': this.form // 其他信息这里，键值对形式
          }
          service.newAddPoint(param).then(res => {
            this.loading = false
            this.$Message.success('添加成功')
            setTimeout(() => {
              res.attribute.objectSeries = backArr
              _this.$store.state.addTreeNode = res
            }, 0)
            this.close()
            this.description = ''
            this.name = ''
            // this.form = {
            //   objectSeries: []
            // }
            this.showList = []
          }).catch(err => {
            this.loading = false
            this.form.objectSeries = backArr
            this.$Message.error(err.message)
          })
        }
      },
      property () {
        if (this.selectList.length !== 1) {
          this.$Message.warning('只能勾选一项')
          return
        }
        this.visibleProperties = true
      },
      beforeCloseAdd () {
        this.visibleAdd = false
      },
      closeAdd () {
        this.visibleAdd = false
      },
      handleConfirmAdd () {
        let _this = this
        this.$refs.tree.getCheckedNodes(true).forEach(e => {
          _this.form.objectSeries.push(e.data)
        })
        this.form.objectSeries = this.unique(this.form.objectSeries, 'id')
        this.visibleAdd = false
      },
      unique (arr, name) {
        var hash = {}
        return arr.reduce(function (item, next) {
          hash[next[name]] ? '' : hash[next[name]] = true && item.push(next)
          return item
        }, [])
      },
      beforeCloseProperties () {
        this.visibleProperties = false
      },
      closeProperties () {
        this.visibleProperties = false
      },
      handleConfirmProperties () {
        this.visibleProperties = false
      },
      checkEvent (node, isSelect, halfSelect) {
        console.log(node)
        console.log(isSelect)
        console.log(halfSelect)
        //   value_Analog,
        // value_Multistate,
        // value_Binary,
        // value_String,
        // BinaryInput,
        // BinaryOutput,
        // AnalogInput,
        // AnalogOutput
        switch (node.type) {
          case 'value_Analog':

            break
          case 'value_Multistate':

            break
          case 'value_Binary':

            break
          case 'value_String':

            break
          case 'BinaryInput':

            break
          case 'BinaryOutput':

            break
          case 'AnalogInput':

            break
          case 'AnalogOutput':

            break

          default:
            this.$Message.error('此节点为目录，无法被选择')
            this.$refs.tree.setChecked(node.id, false)
            break
        }
      },
      selectData (selection, row) {
        this.selectList = selection
      }
    }
  }
</script>
<style scoped>
  .fifty-width-box{
    box-sizing:border-box;
    -moz-box-sizing:border-box; /* Firefox */
    -webkit-box-sizing:border-box; /* Safari */
    width:47%;
    float:left;
    margin-right:13px;
  }
  fieldset {
    padding: 12px;
    border-radius: 5px;
    border: solid 2px #d9d9d9
  }
  .bottom-btn{
    margin:20px;
    text-align: center
  }
  .form-item-objectSeries {
    height: 200px;
    overflow: auto;
    margin-bottom: 12px;
    padding: 12px;
    border: solid 1px #d9d9d9;
    border-radius: 1px;
  }
</style>



// WEBPACK FOOTER //
// src/components/notebook/notebook.vue